import React, { useEffect, useState } from 'react';
import useAsyncEffect from 'use-async-effect';
import { Box, Stack, Button } from '@mui/material';

import HomeBottomButtonOptionsSettings from '@core/dashboard/components/HomeBottomBar/HomeBottomButtonOptionsSettings';
import HomeBottomButtonOptionsCam from '@core/dashboard/components/HomeBottomBar/HomeBottomButtonOptionsCam';
import LoadingProgress from '@components/LoadingProgress';
import PermissionsGuide from '@public/images/ChromeOperation.jpg';
import { DeviceSettingVideoViewProps } from './interfaces';
import { useStyles } from './styles';
import { NavigatorPermissionsService } from '@helpers/permissionsService';

const DevicesSettingsVideoView = ({
  setCheckVideo,
  checkVideo,
  cameras,
  selectedCamera,
  selectCamera,
  changingDevice,
  translate,
}: DeviceSettingVideoViewProps) => {
  const classes = useStyles();
  const [showGuide, setShowGuide] = useState(false);

  useAsyncEffect(async () => {
    const grantPermissions = (state: string) => {
      setShowGuide(state !== 'granted');
    };

    const permissionStatus =
      await NavigatorPermissionsService.checkAndEnsurePermission('camera');

    grantPermissions(permissionStatus.state);

    if ('onchange' in permissionStatus) {
      permissionStatus.onchange = () => {
        grantPermissions(permissionStatus.state);
      };
    }
  }, []);

  useEffect(() => {
    return () => {
      setCheckVideo(false);
    };
  }, []);

  return (
    <>
      {showGuide ? (
        <Box sx={classes.permissionsWrapper}>
          <img src={PermissionsGuide} alt="" />
        </Box>
      ) : (
        <Box sx={classes.subRoot} component="div">
          <Stack spacing={2}>
            <HomeBottomButtonOptionsSettings
              devices={cameras}
              handleSelect={(e) => selectCamera(e.target.value)}
              label={translate('settingsModal.cameraDevice')}
              selectedValue={selectedCamera}
            />
          </Stack>
          <Box component="div" sx={{ width: '100%' }}>
            {changingDevice ? (
              <LoadingProgress />
            ) : checkVideo ? (
              <Button
                onClick={() => setCheckVideo(!checkVideo)}
                sx={classes.videoButton}
              >
                <HomeBottomButtonOptionsCam selectedCam={selectedCamera} />
              </Button>
            ) : (
              <Button
                onClick={() => setCheckVideo(!checkVideo)}
                sx={classes.button}
              >
                {translate('settingsModal.checkConfig')}
              </Button>
            )}
          </Box>
        </Box>
      )}
    </>
  );
};

export default DevicesSettingsVideoView;
